'use client';

import { columnInfoGroup } from '@stereoagency/sanity-schema';
import { ColumnInfoGroup as UIColumnInfoGroup } from '@stereoagency/ui';
import flush from 'just-flush';

type Props = typeof columnInfoGroup.schema.columnInfoGroup;

export default function ColumnInfoGroup({ groups, sortDirection }: Props) {
  if (!groups?.length) {
    return null;
  }

  return (
    <UIColumnInfoGroup
      sortDirection={sortDirection}
      entries={groups.map((group) => ({
        title: group.title,
        entries: flush(
          group.cells?.map((cell) => {
            if (!cell.title) return null;
            return {
              title: cell.title,
              subtitle: cell.subtitle
            };
          }) ?? []
        )
      }))}
    />
  );
}
